import React from 'react';
import './styles.css';

const EmptyView = () => (
  <div className='emptyView-wrap'>
    Loading Failed...
  </div>
);

export default EmptyView;
